import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Button,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import "moment-timezone";
import { useMemo, useState, useEffect, useContext } from "react";
import {
  NavLink as DomNavLink,
  useHistory,
  useLocation,
} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { ToastContainer, toast } from "react-toastify";

const RoomImages = () => {
  const history = useHistory();
  const location = useLocation();
  const privileges = useContext(MainContext);
  const [forceRefreshCount, setForceRefreshCount] = useState(0);

  const [details, setDetails] = useState(null);
  const [showLoading, setShowLoading] = useState(false);

  const [roomId, setRoomId] = useState(
    location.state ? location.state.roomId : "",
  );

  const [siteId, setSiteId] = useState(
    location.state ? location.state.siteId : "",
  );

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["installations.site.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    fetchData();
  }, []);

  const fetchData = () => {
    fetch("/api/v1/site/room/images", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        roomId: roomId,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setDetails(actualData.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const deleteImage = (imageId) => {
    setShowLoading(true);
    fetch("/api/v1/site/room/images/delete", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        roomId: roomId,
        imageId: imageId,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status == 200) {
          toast.success("Image deleted successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          setForceRefreshCount((prevValue) => prevValue + 1);
        } else {
          toast.error("A problem occured while deleting the image", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          console.error("");
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Image",
        accessor: "base64Image",
        flex: "3 0 auto",
        Cell: (props) => {
          return (
            <img
              src={props.value}
              alt="Room"
              style={{ width: "100%", height: "auto", maxWidth: "400px" }}
            />
          );
        },
      },
      {
        Header: "Name",
        accessor: "name",
        flex: "1 0 100px",
        Cell: (props) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              {props.value}
            </div>
          );
        },
      },
      {
        Header: "",
        accessor: "actions",
        flex: "1 0 100px",
        Cell: (props) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <Button
                onClick={() => deleteImage(props.row.original.id)}
                className="btn-round"
                color="info"
                type="submit"
              >
                Delete
              </Button>
            </div>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <ToastContainer />
      <LoadingOverlay
        active={showLoading}
        spinner
        text="Loading"
        className={showLoading ? "loading" : ""}
      />
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/installations/site/list",
                      }}
                    >
                      Hotels
                    </DomNavLink>
                    <i>&lt;{details ? details.siteName : ""}&gt;</i>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/installations/site/details",
                        state: {
                          siteId: siteId,
                          status: "all",
                        },
                      }}
                    >
                      Endpoint
                    </DomNavLink>
                    <i>&lt;{details ? details.number : ""}&gt;</i>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <DomNavLink
                      to={{
                        pathname: "/admin/installations/site/endpoint/details",
                        state: {
                          siteId: siteId,
                          roomId: roomId,
                        },
                      }}
                    >
                      Details
                    </DomNavLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>Images</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="h-100">
              <CardBody className="d-flex flex-column">
                <ReactTable
                  query="/api/v1/site/room/images/list"
                  columns={columns}
                  param={roomId}
                  title="RoomImages"
                  forceRefresh={forceRefreshCount}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default RoomImages;
